'use client';

import { cn } from '@holistic/components';

import type { ComponentType, ReactNode } from 'react';

type FlowCardProps = {
  icon?: ComponentType<{ className?: string }>;
  title?: string;
  /** Başlık şeridinin sağına eklenen içerik (ör. bir bağlantı). */
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
};

/** Talep akışındaki kartların ortak kabuğu: ince çerçeve + isteğe bağlı başlık şeridi. */
const FlowCard = ({
  icon: Icon,
  title,
  action,
  children,
  className,
  bodyClassName,
}: FlowCardProps) => (
  <section
    className={cn(
      'overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-xs',
      className
    )}
  >
    {title && (
      <header className="flex items-center justify-between gap-4 border-b border-gray-100 bg-gray-50/60 px-5 py-3">
        <div className="flex items-center gap-2">
          {Icon && <Icon className="size-3.5 text-gray-400" />}
          <h2 className="text-[11px] font-semibold tracking-widest text-gray-500 uppercase">
            {title}
          </h2>
        </div>
        {action}
      </header>
    )}
    <div className={bodyClassName}>{children}</div>
  </section>
);

export default FlowCard;
